// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.all-emoji[data-v-7c16eb02] {\n  font-size: 1.8rem;\n}\n", ""]);
// Exports
module.exports = exports;
